module.exports = __webpack_public_path__ + "static/img/icon-price-discounts-makeup.a73f846d.png";